require("-!/Users/ice_vita/Kuna/support-portal/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!style-loader!css-loader!sass-loader!/Users/ice_vita/Kuna/support-portal/node_modules/bootstrap-sass-loader/bootstrap-sass-styles.loader.js!/Users/ice_vita/Kuna/support-portal/src/theme/bootstrap.config.prod.js");
require("-!/Users/ice_vita/Kuna/support-portal/node_modules/bootstrap-sass-loader/bootstrap-sass-scripts.loader.js!/Users/ice_vita/Kuna/support-portal/src/theme/bootstrap.config.prod.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap-sass-loader/index.loader.js!./src/theme/bootstrap.config.prod.js
 ** module id = 687
 ** module chunks = 0
 **/